import { render } from "./prescription-dialog.vue?vue&type=template&id=2b6c7ea1&scoped=true"
import script from "./prescription-dialog.vue?vue&type=script&lang=js"
export * from "./prescription-dialog.vue?vue&type=script&lang=js"

import "./prescription-dialog.vue?vue&type=style&index=0&id=2b6c7ea1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6c7ea1"]])

export default __exports__